import axios from 'axios';

// SMTPJS Configuration
// const SMTP_HOST = 'mail.tazatropics.com';
// const SMTP_USERNAME = 'news@tazatropics.com';
// const SMTP_PASSWORD = 'Zfz60J7AXso2=!RD';
const FROM_EMAIL = 'news@tazatropics.com';
const FROM_NAME = 'Taza Tropics';

// Brevo API Configuration
const BREVO_API_URL = 'https://api.brevo.com/v3/smtp/email';
const BREVO_API_KEY = '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';

const buildOrderEmailHtml = ({ orderId, recipientName, items, total, grandTotal, tax, deliveryCharge, address, paymentMethod }) => {
  const itemsHtml = (items || []).map(item => {
    const variantText = item.selectedVariation ? ` - ${item.selectedVariation.title}` : '';
    const discountValue = parseFloat(item.discount) || 0;
    const itemPrice = discountValue > 0 ? parseFloat(item.sell_price || item.price || 0) : parseFloat(item.original_price || item.price || 0);
    return `
      <tr>
        <td style="padding: 10px; border-bottom: 1px solid #eee;">${item.name || 'Item'}${variantText}</td>
        <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: center;">${item.quantiy || item.quantity || 1}</td>
        <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: right;">$${itemPrice.toFixed(2)}</td>
        <td style="padding: 10px; border-bottom: 1px solid #eee; text-align: right;">$${(itemPrice * (item.quantiy || item.quantity || 1)).toFixed(2)}</td>
      </tr>
    `;
  }).join('');

  let addressDetails = '';
  if (address) {
    const showHouse = address.house && (!address.address || !address.address.toLowerCase().includes(address.house.toLowerCase()));
    const showLandmark = address.landmark && (!address.address || !address.address.toLowerCase().includes(address.landmark.toLowerCase()));
    const showPincode = address.pincode && (!address.address || !address.address.toLowerCase().includes(address.pincode.toLowerCase()));

    addressDetails = `
      ${showHouse ? address.house : ''}${showHouse && showLandmark ? ', ' : ''}${showLandmark ? address.landmark : ''}${(showHouse || showLandmark) ? '<br>' : ''}
      ${address.address || ''}
      ${showPincode ? '<br>' + address.pincode : ''}
    `;
  }

  const addressHtml = address ? `
    <div style="margin: 20px 0; padding: 15px; background-color: #f9f9f9; border-radius: 5px;">
      <h3 style="margin: 0 0 10px 0; color: #333;">Delivery Address</h3>
      <p style="margin: 5px 0; color: #666;">
        ${addressDetails}
      </p>
    </div>
  ` : '';

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
    </head>
    <body style="font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px;">
      <div style="background-color: #4CAF50; color: white; padding: 20px; text-align: center; border-radius: 5px 5px 0 0;">
        <h1 style="margin: 0;">Order Notification</h1>
      </div>
      <div style="background-color: #f9f9f9; padding: 20px; border: 1px solid #ddd; border-top: none;">
        <p>Hi <strong>${recipientName || 'Team'}</strong>,</p>
        <p>An order has been completed. Here are the details:</p>
        <div style="background-color: white; padding: 15px; margin: 20px 0; border-radius: 5px;">
          <h3 style="margin: 0 0 10px 0; color: #4CAF50;">Order Details</h3>
          <p style="margin: 5px 0;"><strong>Order ID:</strong> #${orderId}</p>
          <p style="margin: 5px 0;"><strong>Payment Method:</strong> ${paymentMethod || 'N/A'}</p>
          <p style="margin: 5px 0;"><strong>Order Date:</strong> ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
        ${addressHtml}
        <div style="margin: 20px 0;">
          <h3 style="margin: 0 0 15px 0; color: #333;">Order Items</h3>
          <table style="width: 100%; border-collapse: collapse; background-color: white;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">Item</th>
                <th style="padding: 10px; text-align: center; border-bottom: 2px solid #ddd;">Qty</th>
                <th style="padding: 10px; text-align: right; border-bottom: 2px solid #ddd;">Price</th>
                <th style="padding: 10px; text-align: right; border-bottom: 2px solid #ddd;">Total</th>
              </tr>
            </thead>
            <tbody>
              ${itemsHtml}
            </tbody>
          </table>
        </div>
        <div style="background-color: white; padding: 15px; margin: 20px 0; border-radius: 5px;">
          <table style="width: 100%;">
            <tr>
              <td style="padding: 5px; text-align: right; color: #666;">Subtotal:</td>
              <td style="padding: 5px; text-align: right; font-weight: bold; width: 100px;">$${(total || 0).toFixed(2)}</td>
            </tr>

            <tr>
              <td style="padding: 5px; text-align: right; color: #666;">Delivery Charge:</td>
              <td style="padding: 5px; text-align: right; font-weight: bold;">$${(deliveryCharge || 0).toFixed(2)}</td>
            </tr>
            <tr style="border-top: 2px solid #4CAF50;">
              <td style="padding: 10px 5px; text-align: right; font-size: 18px; color: #4CAF50;">Grand Total:</td>
              <td style="padding: 10px 5px; text-align: right; font-size: 18px; font-weight: bold; color: #4CAF50;">$${(grandTotal || 0).toFixed(2)}</td>
            </tr>
          </table>
        </div>
      </div>
      <div style="text-align: center; padding: 20px; color: #666; font-size: 12px;">
        <p style="margin: 5px 0;">© ${new Date().getFullYear()} Taza Tropics. All rights reserved.</p>
      </div>
    </body>
    </html>
  `;
};

export const sendSmtpjsOrderEmail = async (orderData) => {
  try {
    if (!window.Email) {
      throw new Error('SMTPJS (window.Email) is not loaded.');
    }

    const htmlContent = buildOrderEmailHtml(orderData);

    const emailConfig = {
      Host: 'mail.tazatropics.com',
      Username: 'news@tazatropics.com',
      Password: 'Zfz60J7AXso2=!RD',
      To: orderData.recipientEmail,
      From: 'news@tazatropics.com',
      Subject: orderData.subject || `Order Notification #${orderData.orderId}`,
      Body: htmlContent
    };

    console.log('Sending email via SMTPJS to:', emailConfig.To);
    const message = await window.Email.send(emailConfig);
    console.log('SMTPJS response:', message);

    if (message === 'OK') {
      return { success: true, message };
    } else {
      return { success: false, error: message };
    }
  } catch (error) {
    console.error('SMTPJS email error:', error.message || error);
    return { success: false, error: error.message || error };
  }
};

export const sendBrevoOrderEmail = async (orderData) => {
  try {
    const htmlContent = buildOrderEmailHtml(orderData);

    const emailPayload = {
      sender: {
        name: FROM_NAME,
        email: FROM_EMAIL
      },
      to: [
        {
          email: orderData.recipientEmail,
          name: orderData.recipientName || orderData.recipientEmail
        }
      ],
      replyTo: {
        email: FROM_EMAIL,
        name: FROM_NAME
      },
      subject: orderData.subject || `Order Notification #${orderData.orderId}`,
      htmlContent
    };

    const response = await axios.post(BREVO_API_URL, emailPayload, {
      headers: {
        accept: 'application/json',
        'api-key': BREVO_API_KEY,
        'content-type': 'application/json'
      }
    });

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Brevo order email error:', error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data || error.message
    };
  }
};
/**
 * Send simple notification email
 * @param {Object} data - Email data
 */
export const sendSimpleEmail = async ({ to, subject, message }) => {
  try {
    const emailPayload = {
      sender: {
        name: FROM_NAME,
        email: FROM_EMAIL
      },
      to: [
        {
          email: to
        }
      ],
      subject: subject,
      htmlContent: `
        <div style="font-family: Arial, sans-serif; padding: 20px;">
          <h2 style="color: #4CAF50;">${subject}</h2>
          <p>${message}</p>
          <hr>
          <p style="color: #666; font-size: 12px;">Taza Tropics - Fresh Tropical Fruits</p>
        </div>
      `
    };

    const response = await axios.post(BREVO_API_URL, emailPayload, {
      headers: {
        'accept': 'application/json',
        'api-key': BREVO_API_KEY,
        'content-type': 'application/json'
      }
    });

    return {
      success: true,
      messageId: response.data.messageId
    };

  } catch (error) {
    console.error('Brevo email error:', error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data || error.message
    };
  }
};
